import { createContext } from 'react';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

type MyCardsLayoutContextValue = {
  bottomSheetHeight: number;
  defaultRarity: Rarity;
};

export const MyCardsLayoutContext = createContext<MyCardsLayoutContextValue>({
  bottomSheetHeight: 0,
  defaultRarity: Rarity.limited,
});
